class SpecificationsSection {
  constructor() {
    this.tooltipPopup = document.getElementById('specification-tooltip-popup');
    this.tooltipContent = document.getElementById('specification-tooltip-content');
    this.tooltipTitle = document.getElementById('specification-tooltip-title');
    this.tooltipClose = document.getElementById('specification-tooltip-close');
    this.showMoreButton = document.getElementById('specifications-show-more');
    this.hiddenColumns = document.getElementById('specifications-hidden');
    
    this.init();
  }

  init() {
    // Initialize tooltip triggers
    this.initTooltips();
    
    // Initialize show more button
    this.initShowMore();
    
    // Close tooltip on outside click
    this.initTooltipClose();
  }

  initTooltips() {
    // Use event delegation
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.specification-tooltip-trigger');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        this.showTooltip(trigger);
      }
    });
  }

  showTooltip(trigger) {
    if (!this.tooltipPopup) return;
    
    const tooltipText = trigger.getAttribute('data-tooltip');
    const tooltipTitleText = trigger.getAttribute('data-title');
    if (!tooltipText) return;

    // Set title and content
    if (this.tooltipTitle && tooltipTitleText) {
      this.tooltipTitle.textContent = tooltipTitleText;
    }
    if (this.tooltipContent) {
      this.tooltipContent.textContent = tooltipText;
    }
    
    // Show popup - centered on screen
    this.tooltipPopup.classList.remove('hidden');
  }

  hideTooltip() {
    if (this.tooltipPopup) {
      this.tooltipPopup.classList.add('hidden');
    }
  }

  initTooltipClose() {
    // Close button
    if (this.tooltipClose) {
      this.tooltipClose.addEventListener('click', (e) => {
        e.stopPropagation();
        this.hideTooltip();
      });
    }
    
    // Close on outside click
    document.addEventListener('click', (e) => {
      if (this.tooltipPopup && 
          !this.tooltipPopup.contains(e.target) && 
          !e.target.closest('.specification-tooltip-trigger')) {
        this.hideTooltip();
      }
    });
    
    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.tooltipPopup && !this.tooltipPopup.classList.contains('hidden')) {
        this.hideTooltip();
      }
    });
  }

  initShowMore() {
    if (!this.showMoreButton || !this.hiddenColumns) return;
    
    let isExpanded = false;
    
    this.showMoreButton.addEventListener('click', () => {
      const svg = this.showMoreButton.querySelector('svg');
      const textSpan = document.getElementById('specifications-show-more-text');
      if (isExpanded) {
        // Collapse
        this.hiddenColumns.classList.add('hidden');
        this.showMoreButton.setAttribute('aria-expanded', 'false');
        if (svg) svg.style.transform = 'rotate(0deg)';
        if (textSpan) textSpan.textContent = 'Show More';
        isExpanded = false;
      } else {
        // Expand
        this.hiddenColumns.classList.remove('hidden');
        this.showMoreButton.setAttribute('aria-expanded', 'true');
        if (svg) svg.style.transform = 'rotate(180deg)';
        if (textSpan) textSpan.textContent = 'Show Less';
        isExpanded = true;
        
        // Re-initialize tooltips for newly visible columns
        setTimeout(() => {
          this.initTooltips();
          this.hiddenColumns.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 100);
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.specifications-section')) {
      new SpecificationsSection();
    }
  });
} else {
  if (document.querySelector('.specifications-section')) {
    new SpecificationsSection();
  }
}

